import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridColumnProps } from "ag-grid-react";

import SharedGrid from "../Common/SharedGrid";

type CallsListGridProps = {
  tableColumns: AgGridColumnProps[];
  tableRows: any[];
};

export default function CallsListGrid({ tableColumns, tableRows }: CallsListGridProps) {
  return (
    <SharedGrid
      tableColumns={tableColumns}
      tableRows={tableRows}
      showPagination={true}
      paginationPageSize={40} // max 40 because of max audio players per page: https://stackoverflow.com/questions/68480528/blocked-attempt-to-create-a-webmediaplayer-as-there-are-too-many-webmediaplayers
      nodeIdColumnName="_metadata.id"
      showSearchBar
      showDownloadAsCsvButton
    />
  );
}
